import React from 'react';
import {
  BundleContainer,
  BundleItem,
  CancelButton,
  CancelContainer,
  FooterRow,
  FreePreviewWrapper,
  MediaFooter,
  RepresentativeMedia,
  TimeText,
} from './MassDMBundle.styles';
import Image from '../../utils/Image/Image';
import { formatPrice } from '../../../utils/util';
import { format, isAfter } from 'date-fns';
import Video from '../../utils/Video/Video';
import { ALBUM_MEDIA_TYPE } from '../../../utils/constants';

const MassDMBundle = ({ item, onCancel }) => {
  return (
    <BundleContainer>
      {item.representativeMedia && (
        <RepresentativeMedia>
          <FreePreviewWrapper>FREE PREVIEW</FreePreviewWrapper>
          {item.representativeMedia.type === ALBUM_MEDIA_TYPE.PHOTO ? (
            <Image src={item.representativeMedia.url} />
          ) : (
            <Video src={item.representativeMedia.url} />
          )}
        </RepresentativeMedia>
      )}
      {item.bundle.media.map(({ thumbnailUrl }, index) => (
        <BundleItem key={index}>
          <Image src={thumbnailUrl} alt={`Bundle media ${index + 1}`} />
        </BundleItem>
      ))}
      <MediaFooter $role={'INFLUENCER'}>
        <FooterRow>
          <TimeText $role={'INFLUENCER'}>Cost: {item.cost ? `$${formatPrice(item.cost)}` : 'Free'}</TimeText>
        </FooterRow>
        {item.scheduleDate && (
          <FooterRow>
            <TimeText $role={'INFLUENCER'}>Scheduled: {format(item.scheduleDate, 'MMM d, yyyy HH:mm')}</TimeText>
          </FooterRow>
        )}
        {item.cancelledAt && (
          <FooterRow>
            <TimeText $role={'INFLUENCER'}>Canceled: {format(item.cancelledAt, 'MMM d, yyyy HH:mm')}</TimeText>
          </FooterRow>
        )}
        {item.expireInMinutes && (
          <FooterRow>
            <TimeText $role={'INFLUENCER'}>Expire In: {item.expireInMinutes}min</TimeText>
          </FooterRow>
        )}
        <FooterRow>
          <TimeText $role={'INFLUENCER'}> {item.text}</TimeText>
        </FooterRow>
        {item.scheduleDate && isAfter(item.scheduleDate, new Date()) && !item.cancelledAt && (
          <FooterRow>
            <CancelContainer>
              <CancelButton onClick={() => onCancel(item._id)}>Cancel</CancelButton>
            </CancelContainer>
          </FooterRow>
        )}
        <FooterRow>
          <TimeText $role={'INFLUENCER'} />
          <TimeText $role={'INFLUENCER'}>{format(item.createdAt, 'HH:mm')}</TimeText>
        </FooterRow>
      </MediaFooter>
    </BundleContainer>
  );
};

export default MassDMBundle;
